import Storage from '@/utils/storage'
// 通用
const ui = Storage.get('admininfo')
// let homeUrl = ''
// if (ui != null) {
//   homeUrl = 'http://' + ui.siteUrl
// }
const baseUrl = process.env.VUE_APP_API
const upimage = baseUrl + '/common/uploadimagefile'
const upfile = baseUrl + '/common/uploadfile'
const upmedia = baseUrl + '/common/uploadmediafile'
const deletefile = baseUrl + '/common/deletefile'
const upimage1 = baseUrl + '/common/upimage'
// 登录
const validatecode = baseUrl + '/account/vcode'
const login = baseUrl + '/account/login'
const logout = baseUrl + '/account/logout'
const savepwd = baseUrl + '/account/savepwd'
const userinfo = baseUrl + '/account/userinfo'
// 系统配置信息
const config = baseUrl + '/config'
const configsave = baseUrl + '/config/save'
// 功能模块信息
const modulelist = baseUrl + '/module/list'
const modulenavmenu = baseUrl + '/module/navmenu'
const moduledownmenu = baseUrl + '/module/downmenu'
const moduleid = baseUrl + '/module'
const modulesave = baseUrl + '/module/save'
const moduledel = baseUrl + '/module/del'
const moduleenable = baseUrl + '/module/enable'
// 部门信息
const depalist = baseUrl + '/department/list'
const depadowndepa = baseUrl + '/department/downdepa'
const depaid = baseUrl + '/department'
const depasave = baseUrl + '/department/save'
const depadel = baseUrl + '/department/del'
const depaenable = baseUrl + '/department/enable'
// 管理用户信息
const adminlist = baseUrl + '/admin/list'
const adminid = baseUrl + '/admin'
const adminsave = baseUrl + '/admin/save'
const admindel = baseUrl + '/admin/del'
const adminenable = baseUrl + '/admin/enable'
const adminrolelist = baseUrl + '/admin/rolelist'
const adminsaveset = baseUrl + '/admin/saveset'
// 角色信息
const rolelist = baseUrl + '/role/list'
const roleid = baseUrl + '/role'
const rolesave = baseUrl + '/role/save'
const roledel = baseUrl + '/role/del'
const roleenable = baseUrl + '/role/enable'
const rolegetmodulelist = baseUrl + '/role/getmodulelist'
const rolesaveset = baseUrl + '/role/saveset'
const roleadminlist = baseUrl + '/role/adminlist'
// 日志信息
const loglist = baseUrl + '/log/list'
const logid = baseUrl + '/log'
const logdel = baseUrl + '/log/del'
const logimportexcel = baseUrl + '/log/ImportExcel'
const logexportexcel = baseUrl + '/log/ExportExcel'
// 字典类别
const dictlist = baseUrl + '/dictionary/list'
const dictid = baseUrl + '/dictionary'
const dictsave = baseUrl + '/dictionary/save'
const dictdel = baseUrl + '/dictionary/del'
const dictenable = baseUrl + '/dictionary/enable'
// 字典项
const dictitemlist = baseUrl + '/dictionary/itemlist'
const dictitemid = baseUrl + '/dictionary/item'
const dictitemsave = baseUrl + '/dictionary/itemsave'
const dictitemdel = baseUrl + '/dictionary/itemdel'
const dictitemenable = baseUrl + '/dictionary/itemenable'
const dictItemListByCode = baseUrl + '/dictionary/itemListByCode'

// 业务配置信息
const businessconfig = baseUrl + '/businessconfig'
const businessconfigsave = baseUrl + '/businessconfig/save'

// 文章信息
const newslist = baseUrl + '/news/list'
const newsid = baseUrl + '/news'
const newssave = baseUrl + '/news/save'
const newsdel = baseUrl + '/news/del'
const newsenable = baseUrl + '/news/enable'
const newsqueue = baseUrl + '/news/queue'

// 货场信息
const yardlist = baseUrl + '/yard/list'
const yardyardlist = baseUrl + '/yard/yardlist'
const yardid = baseUrl + '/yard'
const yardsave = baseUrl + '/yard/save'
const yarddel = baseUrl + '/yard/del'
const yardenable = baseUrl + '/yard/enable'
const yardqueue = baseUrl + '/yard/queue'
const yardaudit = baseUrl + '/yard/audit'

// 货场黑名单信息
const yardblacklistlist = baseUrl + '/yardblacklist/list'
const yardblacklistid = baseUrl + '/yardblacklist'
const yardblacklistsave = baseUrl + '/yardblacklist/save'
const yardblacklistdel = baseUrl + '/yardblacklist/del'
const yardblacklistenable = baseUrl + '/yardblacklist/enable'
const yardblacklistqueue = baseUrl + '/yardblacklist/queue'

// 车辆信息
const vehiclelist = baseUrl + '/vehicle/list'
const vehicleid = baseUrl + '/vehicle'
const vehiclesave = baseUrl + '/vehicle/save'
const vehicledel = baseUrl + '/vehicle/del'
const vehicleenable = baseUrl + '/vehicle/enable'
const vehiclequeue = baseUrl + '/vehicle/queue'

// 场地预约信息
const reservelist = baseUrl + '/reserve/list'
const reserveid = baseUrl + '/reserve'
const reserveget = baseUrl + '/reserve/reserve'
const reservesave = baseUrl + '/reserve/save'
const reservedel = baseUrl + '/reserve/del'
const reserveflowlist = baseUrl + '/reserve/flowlist'
const reserveflowstate = baseUrl + '/reserve/flowstate'
const reserveflowlistbystep = baseUrl + '/reserve/flowlistbystep'
const reserveexportexcel = baseUrl + '/reserve/ExportExcel'

export default {
  // webUrl,
  ui,
  upimage,
  upimage1,
  upfile,
  upmedia,
  deletefile,
  validatecode,
  login,
  userinfo,
  logout,
  savepwd,
  config,
  configsave,
  modulelist,
  modulenavmenu,
  moduledownmenu,
  moduleid,
  modulesave,
  moduledel,
  moduleenable,
  depalist,
  depadowndepa,
  depaid,
  depasave,
  depadel,
  depaenable,
  adminlist,
  adminid,
  adminsave,
  admindel,
  adminenable,
  adminrolelist,
  adminsaveset,
  rolelist,
  roleid,
  rolesave,
  roledel,
  roleenable,
  rolegetmodulelist,
  rolesaveset,
  roleadminlist,
  loglist,
  logid,
  logdel,
  logimportexcel,
  logexportexcel,
  dictlist,
  dictid,
  dictsave,
  dictdel,
  dictenable,
  dictitemlist,
  dictitemid,
  dictitemsave,
  dictitemdel,
  dictitemenable,
  dictItemListByCode,
  businessconfig,
  businessconfigsave,
  newslist,
  newsid,
  newssave,
  newsdel,
  newsenable,
  newsqueue,
  yardlist,
  yardyardlist,
  yardid,
  yardsave,
  yarddel,
  yardenable,
  yardqueue,
  yardaudit,
  yardblacklistlist,
  yardblacklistid,
  yardblacklistsave,
  yardblacklistdel,
  yardblacklistenable,
  yardblacklistqueue,
  vehiclelist,
  vehicleid,
  vehiclesave,
  vehicledel,
  vehicleenable,
  vehiclequeue,
  reservelist,
  reserveid,
  reserveget,
  reservesave,
  reservedel,
  reserveflowlist,
  reserveflowstate,
  reserveflowlistbystep,
  reserveexportexcel
}
